var getStyle = function (path, values) {
  var pathLiterals = [];
  var pathLiterals = path.split('.'); // [element, attribute, product, theme, modifier]
  var foundValues = values.filter(function (datum) {
    return datum.element === pathLiterals[0] &&
    datum.attribute === pathLiterals[1] &&
    datum.theme === pathLiterals[3] &&
    datum.product === pathLiterals[2]
  })
  if (pathLiterals[3] !== 'default' && foundValues.length) {
    return foundValues.length > 1 ? foundValues[1].specificValue : foundValues[0].specificValue
  } else if (!foundValues.length) {
    throw new Error('No found component for ' + path)
  }
  return foundValues[0].specificValue
}

exports.getStyleHelper = function (data) {
  return function (addedPath) {
    var addedPathLiterals = []; // [element, attribute, modifier]
    var addedPathLiterals = addedPath.split('.');
    var foundValues = data.filter(function(datum) {
      return datum.element === addedPathLiterals[0] &&
      datum.attribute === addedPathLiterals[1] &&
      datum.modifier === (addedPathLiterals[2] || 'default')
    })
    if (addedPathLiterals[2] !== 'default' && foundValues.length) {
      return foundValues.length > 1 ? foundValues[1].specificValue : foundValues[0].specificValue
    } else if (!foundValues.length) {
      throw new Error('No found component for ' + addedPath)
    }
    return foundValues[0].specificValue
  }
}
